import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useEffect } from 'react';
import { fadeInUp } from '../utils/resource.utils'; 

const ScrollAnimatedItem = ({ children, custom = 1, className = '', triggerOnce }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: triggerOnce,   
    threshold: 0.3        
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    } else {
      controls.start('hidden'); 
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      custom={custom}
      variants={fadeInUp}
      initial="hidden"
      animate={controls}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default ScrollAnimatedItem;
